export default __webpack_public_path__ + "static/media/cezar-paraschiv.64750479.png";